export default "__VITE_ASSET__n6lAj4Xj__"